import { Input } from "@/components/ui/input";

// Format a numeric string with dot as thousand separator (Indonesian style).
// e.g. 15000000 -> "15.000.000"
function formatDots(v) {
  if (v === "" || v === null || v === undefined) return "";
  const s = String(v).replace(/\./g, "").replace(/[^\d]/g, "");
  if (!s) return "";
  return s.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

/**
 * RupiahInput — text input yang otomatis menampilkan pemisah ribuan titik (.)
 * dan mengembalikan raw digit string via onChange.
 *
 * Props:
 *  - value       : number | string (digits only)
 *  - onChange(v) : receives raw digit string ("" or "15000000")
 *  - testid, className, placeholder, disabled, ...rest
 */
export default function RupiahInput({ value, onChange, testid, className = "", placeholder = "0", disabled = false, ...rest }) {
  const display = formatDots(value);
  return (
    <Input
      data-testid={testid}
      type="text"
      inputMode="numeric"
      value={display}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(e) => {
        const raw = e.target.value.replace(/\./g, "").replace(/[^\d]/g, "");
        onChange(raw);
      }}
      className={`rounded-none tabular-nums text-right ${className}`}
      {...rest}
    />
  );
}
